import React from 'react';
import ComponentFactory from '../../../../framework/factory/ComponentFactory';
import CoreContainer from '../../../../framework/container/CoreContainer';
import ContainerFactory from '../../../../framework/factory/ContainerFactory';
import CoreComponent from '../../../../framework/component/CoreComponent';
import OrderService from '../../../../service/sales/OrderService';
import OrderHelper from '../../../../helper/OrderHelper';

export class Order extends CoreComponent {
  static className = 'Order';

  constructor(props) {
    super(props);
    this.state = {
      customerGroupId: null, // Estado para armazenar o customer_group_id
    };
  }

  /**
   * get price label
   * @returns {{className: string, value: string}}
   */
  getPriceLabel() {
    return OrderService.getPriceLabel(this.props.order);
  }

  /**
   * handle select order
   * @param order
   */
  selectOrder(order) {
    this.props.selectOrder(order);
  }

  /**
   * Busca os detalhes do pedido quando o componente é montado
   */
  componentDidMount() {
    const { order } = this.props;
    if (order && order.increment_id) {
      OrderService.getByIncrement(order.increment_id)
        .then((orderDetails) => {
          this.setState({ customerGroupId: orderDetails.customer_group_id });
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error fetching order details:', error);
        });
    }
  }

  /**
   * template
   * @returns {*}
   */
  template() {
    // props for component {selectOrder, isActive}
    let { order } = this.props;
    let priceLabel = this.getPriceLabel();

    return (
      <li className="item" onClick={() => this.selectOrder(order)}>
        <div className="item-info">
          <div className="name">
            <span className="value">{order.increment_id}</span>
            <span className={'status ' + order.status}>
              {this.props.t(
                OrderService.getDisplayStatus(order.state, order.status),
              )}
            </span>
          </div>
          <div className="price">
            <span className="value">
              {OrderHelper.formatPrice(order.grand_total, order)}
            </span>
            <span className={'price-label ' + priceLabel.className}>
              {priceLabel.value}
            </span>
          </div>
        </div>
      </li>
    );
  }
}

class OrderContainer extends CoreContainer {
  static className = 'OrderContainer';
}

/**
 * @type {Order}
 */
export default ContainerFactory.get(OrderContainer).withRouter(
  ComponentFactory.get(Order),
);



// WEBPACK FOOTER //
// ./src/view/component/order/order-list/Order.js